module.exports = __webpack_public_path__ + "static/media/1.caecb72a.jpg";